import $ from 'jquery';
import video_scaling_module from './functions/video-scaling.js';
import video_interactions_module from './functions/video-interactions.js';
import video_global_vars_module from './functions/variables.js';

var sm_init_video = function() {

  var video_vars_module = {};

  video_vars_module.user_paused = 0;
  video_vars_module.videos_container = $('.js-video-container');
  video_vars_module.video_element = $('.js-video-container video');
  video_vars_module.play_button = $('.js-play-pause');
  video_vars_module.seek_bar = $('.js-seek-bar');
  video_vars_module.volume_bar = $('.js-volume-bar');
  video_vars_module.fullscreen_button = $('.js-full-screen');
  video_vars_module.play_overlay = $('.js-play-overlay');
  video_vars_module.video = $('.js-video');

  // Events
  // ----------

  // Full Screen Button
  video_vars_module.fullscreen_button.on("click", function() {

    var video_id = $(this).data('video-id');
    video_interactions_module.open_full_screen(video_id);

  });

  // Full Screen (Pause on Return)
  $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', video_scaling_module.full_screen_handler );

  // Play/Pause Video on Click
  video_vars_module.video_element.on("click", function() {

    var video_id = $(this).data('video-id'),
        $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');

    if(!$('#' + video_id).hasClass('js-video--autoplay')) {

      video_interactions_module.toggle_play_pause(video_id, $play_button);

    }

  });

  // Play/Pause Button
  video_vars_module.play_button.on("click", function() {

    var video_id = $(this).data('video-id'),
        $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');

    video_interactions_module.toggle_play_pause(video_id, $play_button);

  });

  // Seek Bar (Changed)
  video_vars_module.seek_bar.on("change", function() {

      var video_id = $(this).data('video-id'),
          video_argument = '#' + video_id,
          $video = $(video_argument),
          $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
          $video_object = $video.get(0);

      video_interactions_module.seekbar_change(video_id);

  });

  // Update the seek bar as the video plays
  video_vars_module.video.on("timeupdate", function() { 

      var video_id = $(this).data('video-id');
      video_interactions_module.seekbar_timeupdate(video_id);

  });

  // Play video when the overlay is clicked
  video_vars_module.play_overlay.on("click", function(e) { 
    e.preventDefault();

      var video_id = $(this).data('video-id'),
          video_argument = '#' + video_id,
          $video = $(video_argument),
          $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
          $video_object = $video.get(0),
          $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');

      video_interactions_module.toggle_play_pause(video_id, $play_button);

  });

  // Show overlay after a video ends
  video_vars_module.video_element.on('ended',function(){

    var video_id = $(this).data('video-id');
    video_interactions_module.reset_video(video_id);

  });

  // Video Sizing - Init 
  $(document).ready(function(){

      // Volume Change
      video_vars_module.volume_bar.on("change", function() {

          var video_id = $(this).data('video-id');
          video_interactions_module.volume_change(video_id);    

      });

      // Video Container Mouse Enter (Show Controls)
      video_vars_module.videos_container.on('mouseenter', function(){

          $(this).find('.o-video-player__video-controls').show();

      });

      // Video Container Mouse Enter (Hide Controls)
      video_vars_module.videos_container.on('mouseleave', function(){

        video_scaling_module.size_video($(this));

      });

  });    

  // Video Sizing - Re-Init on Window Resize
  $(window).resize(function(){

      video_vars_module.videos_container.each(function(index,value){

        var video_id = $(this).data('video-id');

        video_scaling_module.size_video($(this));

      });

  });

  // Pause Video on Modal Close
  // - Uncomment and adjust as needed
  // - Event moved to the 'clicks that close' so the sound stops playing immediately, not when the modal is fully closed
  // ----------
  
  // $('.js-video-modal-close').on("click", function(e) { 

  //     var video_id = $(this).data('video-id'),
  //         video_argument = '#' + video_id,
  //         $video = $(video_argument),
  //         $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
  //         $video_object = $video.get(0),  
  //         $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');  

  //     if ($video.hasClass(video_id)) {
  //         video_interactions_module.pause_video($video_object, $play_button, $video_overlay);
  //     }

  // });

  // $('.reveal-overlay').on("click", function(e) { 
  //   if (e.target !== this) return;
    
  //   var video = $(this).find('.js-video-container');

  //   var video_id = video.data('video-id'),
  //       video_argument = '#' + video_id,
  //       $video = $(video_argument),
  //       $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
  //       $video_object = $video.get(0),    
  //       $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');  

  //   if ($video.hasClass(video_id)) {
  //       video_interactions_module.pause_video($video_object, $play_button, $video_overlay);
  //   }

  // });

}

$(document).ready(function(){
  sm_init_video();
});

window.sm_init_video = sm_init_video;